(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-tags"] && !Shopify.designMode) return;
  try {
    (function() {
    // Handle tag link clicks to trigger blog filtering
    function handleTagClick(e) {
      const tagLink = e.target.closest('.blog-post-tag');
      if (!tagLink) return;

      const href = tagLink.getAttribute('href');
      if (!href || !href.includes('#')) return;

      // Extract tag from hash
      const hash = href.split('#')[1];
      if (!hash) return;

      const blogPath = href.split('#')[0];
      const isOnBlogPage = window.location.pathname === blogPath || window.location.pathname.includes('/blogs/');

      // If not on blog page, allow normal navigation
      if (!isOnBlogPage) {
        return; // Let browser handle navigation
      }

      // On blog page, prevent default and trigger filter
      e.preventDefault();

      // Try to find and click the corresponding filter button
      const filterButton = document.querySelector(`.blog-filter-button[data-filter="${hash}"]`);
      if (filterButton) {
        filterButton.click();
        // Update URL hash
        history.replaceState(null, '', blogPath + '#' + hash);
        return;
      }

      // If no filter button, update hash and let BlogFilters handle it on init
      history.replaceState(null, '', blogPath + '#' + hash);
      
      // Trigger a custom event that BlogFilters might listen to
      window.dispatchEvent(new CustomEvent('blog-filter-hash', { detail: { hash } }));
    }

    // Add click listener
    document.addEventListener('click', handleTagClick);

    // Handle hash changes (when navigating to blog page with hash)
    function handleHashChange() {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return;

      const filterButton = document.querySelector(`.blog-filter-button[data-filter="${hash}"]`);
      if (filterButton) {
        // Small delay to ensure BlogFilters is initialized
        setTimeout(() => {
          if (!filterButton.classList.contains('active')) {
            filterButton.click();
          }
        }, 200);
      }
    }

    // Check hash on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleHashChange);
    } else {
      handleHashChange();
    }

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["value-prop-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('value-prop-grid')) return;

    const finePointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    customElements.define(
      'value-prop-grid',
      class ValuePropGrid extends HTMLElement {
        #cards = [];
        #onDocumentClick = null;
        #onCardClick = null;
        #onKeydown = null;
        #onMediaQueryChange = null;

        connectedCallback() {
          this.#cards = Array.from(this.querySelectorAll('.value-prop-flip-card'));
          this.#onDocumentClick = this.#handleDocumentClick.bind(this);
          this.#onCardClick = this.#handleCardClick.bind(this);
          this.#onKeydown = this.#handleKeydown.bind(this);
          this.#onMediaQueryChange = () => this.#closeAll();

          this.#closeAll();

          this.#cards.forEach((card) => {
            card.addEventListener('click', this.#onCardClick);
            card.addEventListener('keydown', this.#onKeydown);
          });

          document.addEventListener('click', this.#onDocumentClick);
          finePointerQuery.addEventListener('change', this.#onMediaQueryChange);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.#onDocumentClick);
          finePointerQuery.removeEventListener('change', this.#onMediaQueryChange);
          this.#cards.forEach((card) => {
            card.removeEventListener('click', this.#onCardClick);
            card.removeEventListener('keydown', this.#onKeydown);
          });
        }

        #handleCardClick(event) {
          if (finePointerQuery.matches) return;

          event.stopPropagation();
          event.preventDefault();
          const card = event.currentTarget;
          const wasFlipped = card.classList.contains('is-flipped');

          this.#closeAll();

          if (!wasFlipped) {
            card.classList.add('is-flipped');
            card.setAttribute('aria-expanded', 'true');
          }
        }

        #handleKeydown(event) {
          const card = event.currentTarget;

          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            card.click();
          }

          if (event.key === 'Escape') {
            this.#closeAll();
            card.blur();
          }
        }

        #handleDocumentClick(event) {
          if (finePointerQuery.matches) return;
          if (this.contains(event.target)) return;
          this.#closeAll();
        }

        #closeAll() {
          this.#cards.forEach((card) => {
            card.classList.remove('is-flipped');
            card.setAttribute('aria-expanded', 'false');
          });
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
